import Routes from "../../../../pages/Transactions/Routes";
import RoutesNewEdit from "../../../../pages/Transactions/Routes/NewEdit";
import RoutesDetail from "../../../../pages/Transactions/Routes/Detail";

const routerRoutes = [
    {
        key: "routes",
        path: "/transactions/routes",
        element: <Routes />,
    },
    {
        key: "routes",
        path: "/transactions/routes/new",
        element: <RoutesNewEdit />,
    },
    {
        key: "routes",
        path: "/transactions/routes/detail/:id",
        element: <RoutesDetail />,
    },
    {
        key: "routes",
        path: "/transactions/routes/:id",
        element: <RoutesDetail />,
    },
]

export default routerRoutes
